import { render, staticRenderFns } from "./ItemGroupAutocomplete.vue?vue&type=template&id=2fae1390&scoped=true&"
import script from "./ItemGroupAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae1390",
  null
  
)

export default component.exports